// @flow
import { OpenModal } from 'app/common/ui/PlainFilter';

export default OpenModal;
